import {createSelector} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {IResourcesState} from "../../state/resources/resources.state";

export const selectResources = createSelector(
  (state: IAppState) => state.resources,
  (state:IResourcesState) => state
);
